// src/components/MeteoBadge/MeteoPopover.styles.tsx
import { Box, Divider, IconButton, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const NEUTRAL_COLOR = '#333239';
export const SECONDARY_COLOR = '#504e5a';
export const BORDER_COLOR = '#ebebee';

export const PopoverRoot = styled(Stack)({
  minWidth: '32rem',
  padding: '0.75rem',
  gap: '0.5rem',
});

export const CloseButton = styled(IconButton)({
  width: '2.5rem',
  height: '2.5rem',
  borderRadius: '0.75rem',
  backgroundColor: '#FEFEFE',
  boxShadow: '0 1px 8px 0 rgba(0, 0, 0, 0.15)',
  flexShrink: 0,
  marginLeft: '1rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  transition: 'all 0.1s ease',
  '&:hover': {
    backgroundColor: '#f5f5f5',
    transform: 'rotate(90deg)',
  },
});

export const PopoverDivider = styled(Divider)({
  border: 'none',
  height: '1px',
  backgroundColor: BORDER_COLOR,
  borderRadius: '19px',
  transform: 'rotate(0.04deg)',
  alignSelf: 'stretch',
});

export const HourCardRoot = styled(Stack)({
  flex: 1,
  border: `1px solid ${BORDER_COLOR}`,
  borderRadius: '1rem',
  paddingLeft: '1rem',
  paddingRight: '1rem',
  paddingTop: '0.75rem',
  paddingBottom: '0.75rem',
  alignItems: 'center',
  gap: '0.5rem',
});

export const HourLabel = styled(Typography)({
  fontSize: '0.875rem',
  fontWeight: 500,
  color: NEUTRAL_COLOR,
});

export const TemperatureLabel = styled(Typography)({
  fontSize: '1.125rem',
  fontWeight: 500,
  color: SECONDARY_COLOR,
  lineHeight: '120%',
});

export const MetricValue = styled(Typography)({
  fontSize: '0.875rem',
  fontWeight: 500,
  color: NEUTRAL_COLOR,
  minWidth: '1.75rem',
});

export const WeatherTitle = styled(Typography)({
  fontSize: '0.875rem',
  fontWeight: 500,
  color: NEUTRAL_COLOR,
});

export const LocationName = styled(Typography)({
  fontSize: '0.625rem',
  fontWeight: 500,
  color: NEUTRAL_COLOR,
});

export const OverlookLabel = styled(Typography)({
  fontSize: '0.625rem',
  color: SECONDARY_COLOR,
});

export const LegendLabel = styled(Typography)({
  fontSize: '0.625rem',
  fontWeight: 400,
  lineHeight: '160%',
  color: SECONDARY_COLOR,
});

export const SectionDateLabel = styled(Typography)({
  fontSize: '1rem',
  fontWeight: 500,
  lineHeight: '140%',
  color: NEUTRAL_COLOR,
});

export const IconColorBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'iconColor',
})<{ iconColor: string }>(({ iconColor }) => ({
  '& path': { fill: iconColor },
  display: 'flex',
}));

export const LoadingContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  paddingTop: '2rem',
  paddingBottom: '2rem',
});

export const meteoPopoverPaperSx = {
  borderRadius: '1rem',
  boxShadow: '0px 1px 8px rgba(0,0,0,0.15)',
  bgcolor: '#FEFEFE',
  marginLeft: '0.75rem',
} as const;
